import React from 'react'
import {Box, BoxProps, Image, useMultiStyleConfig} from '@chakra-ui/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

/**
 * @name WeChatQRCode
 *
 * @component
 *
 * @description
 * Renders a box containing a QR Code about "WeChat" social.
 *
 * @returns {React.FC} - Rendered `WeChatQRCode` component.
 */
const WeChatQRCode: React.FC = () => {
    const styles = useMultiStyleConfig('FooterSocials') as Record<string, BoxProps>

    return (
        <Box {...styles.weChatQrCode} data-testid="wechat-qr-code">
            <Image src={getAssetUrl('./static/img/footer/qrcode-wechat.png')} alt="WeChat QR Code" data-testid="wechat-qr-code-image" />
        </Box>
    )
}

export default WeChatQRCode
